import { times } from "lodash";
import { h } from "preact";
import {
  IWidgetConfigurationProps,
  withWidgetConfiguration,
} from "../../../node_modules/@sgwt-widget/core";
import { BasicAgGrid, IHeader } from "../../common/components/AgGrid";
import { ApiBackedComponent } from "../../common/components/ApiBackedComponent";
import { MakeGenericApiCall } from "../../common/generic/generic-api";
import {
  BuildGenericRequest,
  CheckReponseDataForError,
} from "../../common/generic/generic-helper";
import { NbiDimensions } from "../../common/generic/generic-nbi-dimensions";
import { IFilterItem } from "../../common/generic/generic-types";
import { AgFormat } from "../../common/utils/agGridFormat";
import { ITakeClientAndDateProps } from "../../common/utils/types";
import { mapData } from "../utils/helper";

const kpis = "nbi_rol_yr";
const attributes =
  "gbis_credit_date,fpv_bl,fpv_sbl,fpv_oeresctryname,fpv_beresctryname,salesben_team,salesben_sales,product_l3,client_lename";
const sortOrder = "-nbi_rol_yr";
const topN = 100;

interface IState {
  data: any[];
  headers: IHeader[];
}
export class NbiTopDealsClass extends ApiBackedComponent<
  ITakeClientAndDateProps & IWidgetConfigurationProps,
  IState
> {
  public constructor() {
    super();
    this.setState({
      data: [],
    });
  }

  protected shouldFetchApiData(nextProps: ITakeClientAndDateProps): boolean {
    return this.props.client !== nextProps.client;
  }

  protected renderWithDataReady(): JSX.Element {
    return (
      <div style="display:block;height:100%; overflow:hidden">
        <BasicAgGrid
          onChange={this.props.onChange}
          rowData={this.state.data}
          columnDefs={this.state.headers}
          fileName={"Top NBI deal"}
          userSelection={this.props.userSelection}
        />
      </div>
    );
  }

  protected async fetchApiData(props: ITakeClientAndDateProps) {
    this.initCorrelationId();
    const headers = props.headers;

    if (
      props.client === undefined ||
      isNaN(parseInt(props.client.bdrCommercialId, 10))
    ) {
      this.setState({
        data: [],
        headers: [],
      });
      this.setDataStatus("no-client");
      return;
    }
    this.setDataStatus("loading");
    const attr = new NbiDimensions();
    const filter: IFilterItem[] = [
      {
        attribute: attr.CLIENT_GEN_ID,
        equals: true,
        value: props.client.bdrCommercialId,
      },
    ];
    const date =
      props.client.value === undefined
        ? undefined
        : new Date(props.client.value);
    const genericRequest = BuildGenericRequest(
      kpis,
      date,
      attributes,
      topN,
      undefined,
      undefined,
      filter,
      sortOrder
    );
    const responseData = await MakeGenericApiCall(
      headers,
      "nbi",
      genericRequest,
      this.props.widgetConfiguration,
      this.state.correlationId
    );

    const error = CheckReponseDataForError(responseData);
    if (error) {
      this.setState({
        data: [],
        headers: [],
      });
      this.setDataStatus(error);
      this.setStatusText(responseData.statusText);
    } else {
      const result = mapData(responseData);

      if (result.data.length !== 0) {
        this.setState({
          data: result.data,
          headers: [
            {
              field: "Date",
              filter: "date",
              filterParams: { comparator: AgFormat.AgGridDateFilter },
              headerName: "Date",
            },
            { headerName: "BL", field: "BL" },
            { headerName: "SBL", field: "SBL" },
            { headerName: "Team", field: "TeamName" },
            { headerName: "Sales", field: "SalesName" },
            { headerName: "Sales Location", field: "BEResCtry" },
            { headerName: "Originating Country", field: "OEResCtry" },
            { headerName: "Product Level 3", field: "ProductLevel3" },
            {
              cellClass: "text-right",
              comparator: AgFormat.AgNumberComparator,
              field: "Nbi",
              filter: "number",
              filterParams: { comparator: AgFormat.AgNumberComparator },
              headerName: "NBI (K€)",
              valueGetter: AgFormat.AgGridFormatMoney,
            },
          ],
        });
        this.setDataStatus("ready");
      } else {
        this.setState({
          data: [],
          headers: [],
        });
        this.setDataStatus("no-data");
      }
    }
  }
}

export const NbiTopDeals = withWidgetConfiguration(NbiTopDealsClass);
